import * as React from "react";
import {SVGProps} from "react";

export const UnibuddyLogoSvg = (props: SVGProps<SVGSVGElement>) => {
    const {color = "currentColor", ...rest} = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={44}
            height={40}
            fill="none"
            viewBox="0 0 44 40"
            {...rest}
        >
            <path
                fill={color}
                d="M24.445 0v19.262l9.25-.809c.535 6.1-3.49 11.547-9.25 12.979v7.68C35.246 39.111 44 30.354 44 19.555V0H24.445Zm7.333 14.645a2.443 2.443 0 1 1 0-4.889 2.443 2.443 0 1 1 0 4.889Zm-22.54 5.946 10.319-.903V0H0v19.555c0 10.8 8.756 19.554 19.555 19.554v-7.46C14.11 30.797 9.737 26.33 9.237 20.59Zm3.01-10.835a2.444 2.444 0 1 1 0 4.889 2.444 2.444 0 1 1 0-4.889Z"
            />
        </svg>
    );
};
